import React, { useState } from 'react';
import { Modal, Alert, Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';

const ModalDuplicateFile = ({
  visible,
  onCancel,
  onContinue,
  fileName,
  loading = false
}) => {
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const handleOk = () => {
    if (!password.trim()) {
      setPasswordError('Por favor, informe sua senha para continuar');
      return;
    }
    
    setPasswordError('');
    onContinue(password);
  };

  const handleCancel = () => {
    setPassword('');
    setPasswordError('');
    onCancel();
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (passwordError) {
      setPasswordError('');
    }
  };

  return (
    <Modal
      title="Arquivo Duplicado Detectado"
      visible={visible}
      onCancel={handleCancel}
      cancelText="Cancelar"
      okText="Continuar Assim Mesmo"
      onOk={handleOk}
      confirmLoading={loading}
      maskClosable={!loading}
      closable={!loading}
    >
      <Alert
        message="Este arquivo PDF já foi enviado anteriormente"
        description={
          <div style={{ marginTop: '12px' }}>
            <p>
              <strong>Arquivo:</strong> {fileName}
            </p>
            <p style={{ marginBottom: '8px' }}>
              O reenvio deste arquivo pode gerar pedidos duplicados no sistema.
            </p>
            <p style={{ marginBottom: 0 }}>
              Para continuar, confirme sua senha:
            </p>
          </div>
        }
        type="warning"
        showIcon
        style={{
          backgroundColor: '#fffbe6',
          border: '1px solid #ffe58f',
          marginBottom: '16px',
        }}
      />
      
      <Form layout="vertical">
        <Form.Item 
          label="Senha" 
          validateStatus={passwordError ? 'error' : ''}
          help={passwordError}
        >
          <Input.Password
            prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="Digite sua senha"
            value={password}
            onChange={handlePasswordChange}
            disabled={loading}
            onPressEnter={handleOk}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalDuplicateFile;
